import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// used to override BaseAsbtractApi class, allowing for optional functions
export interface BaseAbstractApi<B, IdType = number> {
    deleteByIds?(ids: IdType[]): Observable<null>;
    createBatch?(resources: B[]): Observable<IdType[]>;
    getById?(id: IdType): Observable<B>;

    deleteById?(id: IdType): Observable<IdType>;

    createFull?(resource: B): Observable<B>;
    updateFull?(resource: B): Observable<B>;
    getFullList?(): Observable<B[]>;
}

// B -> backend api model
@Injectable()
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export abstract class BaseAbstractApi<B, IdType = number> {
    abstract create(resource: B): Observable<IdType>;
    abstract update(resource: B): Observable<IdType>;
}
